function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-e72444c6\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector?type=styles&index=0!./NprogressContainer.vue")
}
var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./NprogressContainer.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-e72444c6\",\"hasScoped\":false}!../../vue-loader/lib/selector?type=template&index=0!./NprogressContainer.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-nprogress/src/NprogressContainer.vue
// module id = 54
// module chunks = 4